/**
 * Which build is this, and where is it running.
 *
 * Until this existed, "what is staging actually serving?" could only be answered by
 * SSHing to the VM and running `git rev-parse`, and a bug report told you the
 * reporter's browser but never which build they were on.
 *
 * The two constants are frozen in at build time by the DefinePlugin in
 * build/webpack.src-prod.conf.js. DefinePlugin only substitutes where a variable is
 * actually referenced, so reading them here is what puts them in the bundle at all.
 *
 * NOT called `currentVersion`: that getter already exists and means the PROJECT's
 * version from History. Two unrelated ideas must not share the word.
 */

// eslint-disable-next-line no-undef
const COMMIT = (typeof process !== 'undefined' && process.env && process.env.VUE_APP_BUILD_COMMIT) || 'dev';
// eslint-disable-next-line no-undef
const DATE = (typeof process !== 'undefined' && process.env && process.env.VUE_APP_BUILD_DATE) || 'local';

/**
 * Environment, derived from the Firebase project rather than a separate variable that
 * could drift out of step with the one that actually decides which backend we talk to.
 */
export function buildEnvironment() {
    const project = (typeof process !== 'undefined' && process.env && process.env.VUE_APP_FIREBASE_PROJECTID) || '';
    if (project === 'qlist-70c1e') return 'production';
    if (project === 'cuelist-staging') return 'staging';
    if (project.indexOf('sandbox') !== -1) return 'sandbox';
    return project || 'unknown';
}

/** The short string shown to a person. Deliberately carries no environment. */
export function buildStamp() {
    return `Cuelist ${DATE} · ${COMMIT}`;
}

/**
 * The full diagnostic, for the clipboard and for bug reports. This one DOES carry the
 * environment: it is useful to us and never displayed to a customer.
 */
export function buildDiagnostic(extra) {
    const lines = [`${buildStamp()}`, `${buildEnvironment()}`];
    if (extra) lines.push(extra);
    if (typeof navigator !== 'undefined' && navigator.userAgent) lines.push(navigator.userAgent);
    return lines.join('\n');
}

export default { buildStamp, buildEnvironment, buildDiagnostic, COMMIT, DATE };


// WEBPACK FOOTER //
// ./src/lib/buildStamp.js